import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class TaskSchedulerType {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  typeName!: string;
}
